export default __webpack_public_path__ + "static/media/(2).07b4d467.jpeg";